import { render, staticRenderFns } from "./AddRelatedParty.vue?vue&type=template&id=2036e038&"
import script from "./AddRelatedParty.vue?vue&type=script&lang=js&"
export * from "./AddRelatedParty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports